import { FavouriteConditionValue } from 'app/types-shared';
import { FilterTypes } from 'app/components/filters/types';

export const createInitialDefaultValue = (favouriteConditionValue: FavouriteConditionValue,
  conditionValues: FavouriteConditionValue[], advancedSearchType?: number) => {

  const code = favouriteConditionValue.code && favouriteConditionValue.code.v;
  const description = favouriteConditionValue.code && favouriteConditionValue.code.d;

  if (advancedSearchType === FilterTypes.CheckBox) {
    return { value: favouriteConditionValue.number };
  }

  return (!!code || code === 0) && {
    value: code,
    description: description
  };
};
